import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import CustomerDebtCorrectionItemForm from "../create/components/CustomerDebtCorrectionItemForm";
import CustomerDebtCorrectionJournalForm from "../create/components/CustomerDebtCorrectionJournalForm";
import CustomerDebtCorrectionItemEditForm from "../edit/components/CustomerDebtCorrectionItemForm";
import CustomerDebtCorrectionJournalEditForm from "../edit/components/CustomerDebtCorrectionJournalForm";
import { useState } from "react";
import { useTranslate, useTheme } from "react-admin";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {children}
    </div>
  );
}

const TabForm = ({ schema, ...props }) => {
  const [value, setValue] = useState(0);

  const t = useTranslate();
  const [theme] = useTheme("light");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const bgcolor = theme !== "dark" ? "grey.200" : "grey.800";

  return (
    <Box sx={{ width: "100%" }}>
      <Box
        sx={{
          borderBottom: 1,
          borderColor: "divider",
          bgcolor: "background.paper",
          mb: 1,
        }}
      >
        <Tabs
          value={value}
          onChange={handleChange}
          aria-label="basic tabs example"
          variant="fullWidth"
        >
          <Tab
            label={t("mine.label.correction")}
            sx={value === 0 ? { bgcolor } : {}}
          />
          <Tab
            label={t("mine.label.journal")}
            sx={value === 1 ? { bgcolor } : {}}
          />
        </Tabs>
      </Box>
      {schema === "edit" ? (
        <>
          <TabPanel value={value} index={0}>
            <CustomerDebtCorrectionItemEditForm />
          </TabPanel>
          <TabPanel value={value} index={1}>
            <CustomerDebtCorrectionJournalEditForm />
          </TabPanel>
        </>
      ) : (
        <>
          <TabPanel value={value} index={0}>
            <Box
                sx={{
                  maxHeight: '300px', // Sesuaikan tinggi maksimum sesuai kebutuhan Anda
                  overflowY: 'auto',
                  border: '1px solid #ccc', // Opsional: untuk visualisasi batas
                  borderRadius: '4px',
                  marginBottom: '24px',
                  p: 1, // Opsional: padding
                }}
              >
              <CustomerDebtCorrectionItemForm />
            </Box>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <Box
                sx={{
                  maxHeight: '300px', // Sesuaikan tinggi maksimum sesuai kebutuhan Anda
                  overflowY: 'auto',
                  border: '1px solid #ccc', // Opsional: untuk visualisasi batas
                  borderRadius: '4px',
                  marginBottom: '24px',
                  p: 1, // Opsional: padding
                }}
              >
              <CustomerDebtCorrectionJournalForm />
            </Box>
          </TabPanel>
        </>
      )}
    </Box>
  );
};

export default TabForm;
